
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop, Watch } from "vue-property-decorator";
import { download } from "@/functions/global.function";

@Component({
  components: {},
  filters,
})
export default class MyCourseAttachment extends Vue {
  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: [] })
  private attachments!: Array<any>;

  @Watch("step")
  private onTrigger() {
    if (this.isLastStep) {
      this.$emit("next");
    }
  }

  private get isLastStep() {
    return this.step === this.maxSteps;
  }
  private get maxSteps() {
    return this.attachments?.length;
  }
  private get attachment() {
    return this.attachments[this.step - 1];
  }
  private get extension() {
    return this.attachment?.attachment
      .split(/[#?]/)[0]
      .split(".")
      .pop()
      .trim()
      .toLowerCase();
  }
  private get isVideo() {
    return ["mp4", "mkv", "mov", "avi"].includes(this.extension);
  }
  private get isPdf() {
    return ["pdf"].includes(this.extension);
  }

  private prev() {
    if (this.step === 1) return;
    this.$emit("nextStep", this.step - 1);
  }

  private next() {
    this.$emit("nextStep", this.step + 1);
  }

  private downloadAttachment() {
    download(
      this.attachment?.attachment,
      this.attachment?.attachment.split("/").pop()
    );
  }
}
